import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendResponse, HttpService, ToastrService } from 'vas-mobile-api';

import { DataExchangeService } from '../services/dataexchange.service';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.css']
})
export class SetPasswordComponent implements OnInit {

  public inputFormGroup: FormGroup;

  constructor(
    private des: DataExchangeService,
    private route: ActivatedRoute,
    private httpService: HttpService,
    private toast: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((map) => {

      this.inputFormGroup = new FormGroup({
        seed: new FormControl(map.get('id')),
        user: new FormControl('', Validators.required),
        password1: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(20), this.passwordValidator()]),
        password2: new FormControl('', [Validators.required])
      }, this.passwordMatchValidator());
    });

    this.des.changeTitelBarName('LABEL_PASSWORD');
  }

  public onSubmit() {
    const inputForm = this.inputFormGroup.value;
    this.httpService.post<BackendResponse<any>>({ pathId: 'resetPassword', payload: inputForm, withToken: false }).subscribe((response) => {
      this.toast.success(response.message);
      this.router.navigate(['login']);
    });
  }

  public passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const pw1Ctrl = control.get('password1');
      const pw2Ctrl = control.get('password2');
      const forbidden = pw1Ctrl.value && pw2Ctrl.value && pw1Ctrl.value !== pw2Ctrl.value;
      return forbidden ? { 'passwordDoesNotMatch': true } : null;
    };

  }

  public omit_special_char(event) {
    let c;
    c = event.charCode;  // k = event.keyCode;  (Both can be used)
    return ((c > 64 && c < 91) || (c > 96 && c < 123) || c === 8 || c === 32 || (c >= 48 && c <= 57));
  }

  public passwordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;
      const hasNumber = /\d/.test(value);
      const hasUpper = /[A-Z]/.test(value);
      const hasLower = /[a-z]/.test(value);
      if (!value || hasNumber && hasUpper && hasLower) {
        return null;
      }
      const result: any = {};
      if (!hasNumber) {
        result.noNumber = true;
      }
      if (!hasUpper) {
        result.noUpper = true;
      }
      if (!hasLower) {
        result.noLower = true;
      }
      return result;
    };
  }

  public get newPasswordErrors(): any {
    return this.inputFormGroup.get('password1').errors;
  }
}
